<template>
  <div class="hot-live">
    <div class="title">
      <div class="title-left">
        <img src="./home_star.png" alt="" />
        <div>明星大神</div>
      </div>
      <router-link to="/news" target="_blank" class="title-right">
        <div>成为大神</div>
        <img src="./share_arr_right.png" alt="" />
      </router-link>
    </div>
    <div class="swiper-container swiper-hot-live">
      <div class="swiper-wrapper">
        <router-link :to="`/liveMatchesTwo/${item.anchorid}`" target="_blank" class="swiper-slide" v-for="(item, index) in anchors" :key="index">
          <div class="hot-wrap">
            <!-- <img class="avatar" :src="item.thumb" /> -->
            <img class="avatar" :src="item.anchor_avatar" alt="" />
            <div class="name text-overflow">{{ item.anchor_name }}</div>
            <div class="hot">
              <img src="./hot.png" class="hot-img" />
              {{ $bigNumber(item.hot) }}
            </div>
            <div class="subs subs-other" @click.prevent="subscription(item.anchorid, index)" v-if="item.isattent">已关注</div>
            <div class="subs" @click.prevent="subscription(item.anchorid, index)" v-else>关注焦点</div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="swiper-button-prev" slot="pagination"></div>
    <div class="swiper-button-next" slot="pagination"></div>
  </div>
</template>

<script>
import Swiper, { Autoplay, Navigation } from "swiper";
Swiper.use([Autoplay, Navigation]);
import { post } from "@/util/http";
import { mapMutations } from "vuex";

export default {
  name: "swiper-hot-live",
  props: {
    anchors: {
      type: Array,
      default: [],
    },
  },
  components: {},
  data() {
    return {};
  },
  watch: {
    anchors() {
      this.$nextTick(() => {
        new Swiper(".swiper-hot-live", {
          loop: false,
          spaceBetween: 40,
          slidesPerView: 6,
          // autoplay: {
          //   delay: 3000, //自动切换的时间间隔，单位ms
          //   stopOnLastSlide: false, //如果设置为true，当切换到最后一个slide时停止自动切换。
          //   disableOnInteraction: false, //用户操作swiper之后，是否禁止autoplay。
          //   reverseDirection: false, //开启反向自动轮播。
          //   waitForTransition: false, //等待过渡完毕。自动切换会在slide过渡完毕后才开始计时。
          // },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    },
  },
  async mounted() {
    // const {
    //   data: { data },
    // } = await post({
    //   url: "/api/live/hotLive",
    //   data: { uid: 0 },
    // });
    // this.anchors = data;
  },
  methods: {
    ...mapMutations(["toggleLogin"]),
    async subscription(anchorid, index) {
      if (this.$store.state.userInfo.id) {
        const {
          data: { data },
        } = await post({
          url: "/api/anchor/attentAnchor",
          data: {
            anchorid: anchorid,
          },
        });
        console.log("item.anchorid", data.type);
        if (data.type) {
          this.anchors[index].isattent = 1;
          this.$message({
            message: "关注成功！",
            type: "success",
          });
        } else {
          this.anchors[index].isattent = 0;
          this.$message({
            message: "取消关注！",
            type: "warning",
          });
        }
      } else {
        this.toggleLogin();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.swiper-button-prev:after {
  display: none;
}
.swiper-button-next:after {
  display: none;
}

.swiper-button-prev {
  background: no-repeat center/100% url("./share_arr_left.png");
  left: 0;
}
.swiper-button-next {
  background: no-repeat center/100% url("./share_arr_right.png");
  right: 0;
}

.hot-live {
  width: 14rem;
  height: 3rem;
  margin: 0 auto;
  position: relative;
}
.title {
  width: 12.14rem;
  height: 0.6rem;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .title-left {
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    color: #fff;
    & > img {
      width: 0.34rem;
      height: 0.34rem;
      margin-right: 0.1rem;
    }
  }
  .title-right {
    display: flex;
    align-items: center;
    font-size: 0.14rem;
    color: #fff;
    & > img {
      width: 0.15rem;
      margin-left: 0.03rem;
    }
  }
}

.swiper-hot-live {
  width: 12.14rem;
}

.hot-wrap {
  border-radius: 0.05rem;
  height: 2.33rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  .avatar {
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 50%;
    margin-top: 0.31rem;
  }
  .name {
    font-size: 0.16rem;
    color: #333;
    // font-weight: bold;
    width: 1.2rem;
    text-align: center;
  }
  .hot {
    display: flex;
    align-items: center;
    color: #666;
    font-size: 0.14rem;
    .hot-img {
      width: 0.12rem;
      height: 0.14rem;
      margin-right: 0.05rem;
    }
  }
  .subs {
    margin-bottom: 0.31rem;
    width: 0.96rem;
    height: 0.28rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(90deg, #29f19c 0%, #02a1f9 100%);
    color: #fff;
    border-radius: 0.28rem;
    font-size: 0.14rem;
    cursor: pointer;
  }
  .subs-other {
    width: 0.96rem;
    height: 0.28rem;
    background: #f0f0f0;
    border: 1px solid rgba(153, 153, 153, 0.3);
    color: #999;
  }
}
</style>
